import './SkeletonLoader.css';

/**
 * Skeleton loader component for better loading states
 */
export const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-image"></div>
    <div className="skeleton-content">
      <div className="skeleton-line skeleton-title"></div>
      <div className="skeleton-line skeleton-text"></div>
      <div className="skeleton-line skeleton-text short"></div>
    </div>
  </div>
);

export const SkeletonBlogCard = () => (
  <div className="skeleton-card skeleton-blog-card">
    <div className="skeleton-image"></div>
    <div className="skeleton-content">
      <div className="skeleton-line skeleton-badge"></div>
      <div className="skeleton-line skeleton-title"></div>
      <div className="skeleton-line skeleton-text"></div>
      <div className="skeleton-line skeleton-text short"></div>
      <div className="skeleton-line skeleton-meta"></div>
    </div>
  </div>
);

export const SkeletonShopCard = () => (
  <div className="skeleton-card skeleton-shop-card">
    <div className="skeleton-image"></div>
    <div className="skeleton-content">
      <div className="skeleton-line skeleton-title"></div>
      <div className="skeleton-line skeleton-text"></div>
      <div className="skeleton-line skeleton-price"></div>
      <div className="skeleton-line skeleton-button"></div>
    </div>
  </div>
);

export const SkeletonText = ({ lines = 3, width = '100%' }) => (
  <div className="skeleton-text-container">
    {Array.from({ length: lines }).map((_, i) => (
      <div 
        key={i} 
        className={`skeleton-line skeleton-text ${i === lines - 1 ? 'short' : ''}`}
        style={{ width: i === lines - 1 ? '60%' : width }}
      ></div>
    ))}
  </div>
);


